function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IyoutubeCircle2 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2602 10.3427C22.9456 10.5272 23.4859 11.0675 23.6704 11.7529C24.0131 13.0049 23.9999 15.6145 23.9999 15.6145C23.9999 15.6145 23.9999 18.2108 23.6704 19.4629C23.4859 20.1482 22.9456 20.6886 22.2602 20.8731C21.0082 21.2026 16 21.2026 16 21.2026C16 21.2026 11.0049 21.2026 9.7397 20.8599C9.05436 20.6754 8.514 20.1351 8.32949 19.4497C8 18.2108 8 15.6013 8 15.6013C8 15.6013 8 13.0049 8.32949 11.7529C8.514 11.0675 9.06754 10.514 9.7397 10.3295C10.9918 10 16 10 16 10C16 10 21.0082 10 22.2602 10.3427ZM18.5701 15.6035L14.4054 18.0022V13.2049L18.5701 15.6035Z",
    fill: "white"
  }));
});